import { Box, Divider, IconButton, LinearProgress, Typography } from "@mui/material";
import { OpenInNew } from "@mui/icons-material";
import { Link } from "react-router-dom";
import { useFields } from "../../../../api/useFields";
import { useRecord } from "../../../../api/useRecord";
import { Groups } from "../../../../components/groups/Groups";
import { customerSurveyOptions } from "../../../customer-surveys/CustomerSurveyOptions";
import { fieldsQuery } from "../../../customer-surveys/customerSurveyRoutes";
import type { LogbookCustomerSurveyItem } from "../../types";

type CustomerSurveyDetailPanelProps = {
	customerSurvey: LogbookCustomerSurveyItem;
};

export const CustomerSurveyDetailPanel = ({ customerSurvey }: CustomerSurveyDetailPanelProps) => {
	const { formatedFields, status: fieldsStatus } = useFields("customer_surveys");
	const initialData = { item: customerSurvey, id: customerSurvey.id, entity: "customer_surveys" };
	const { data: surveyData } = useRecord("customer_surveys", fieldsQuery, customerSurvey.id, { initialData });

	const fullSurvey = surveyData?.item ?? customerSurvey;

	if (fieldsStatus === "loading") return <LinearProgress />;
	if (fieldsStatus === "error") return <Typography>Questionário não foi carregado.</Typography>;

	const fieldsWithoutTreatment = formatedFields.filter((field: any) => field.field !== "treatment");

	return (
		<Box>
			<Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 1 }}>
				<Typography variant="subtitle1" fontWeight="bold" color="primary">
					Questionário de Satisfação
				</Typography>
				<IconButton
					color="secondary"
					component={Link}
					to={`/customer_surveys/${customerSurvey.id}`}
					target="_blank"
					size="small"
				>
					<OpenInNew />
				</IconButton>
			</Box>
			<Divider sx={{ my: 2 }} />
			<Groups
				item={fullSurvey}
				fields={fieldsWithoutTreatment}
				groupsOptions={customerSurveyOptions?.groupsOptions}
			/>
		</Box>
	);
};
